import React, { ReactNode } from 'react'
import { styled } from '@mui/material/styles'

import * as Constants from '~/src/constants'

export type TMainViewProps = {
  open?: boolean
  children: ReactNode
}

const drawerWidth = Constants.DRAWER_WIDTH

const MainStyled = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean
}>(({ theme, open }) => ({
  flexGrow: 1,
  // padding: theme.spacing(3),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}))

/**
 * MainView Component
 *
 * @example
 * ```ts
 *  <MainView open = true><div /></MainView>
 * ```
 * @param __namedParameters TMainViewProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const MainView: React.FC<TMainViewProps> = ({ open = true, children }): JSX.Element => (
  <MainStyled open={open}>{children}</MainStyled>
)
